import React, { Suspense, useState } from "react";
import {
  AppBar,
  Avatar,
  Box,
  IconButton,
  Toolbar,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { Menu as MenuIcon, Close as CloseIcon } from "@mui/icons-material";
import Drawerr from "../sections/header/Drawer";
import { Outlet } from "react-router-dom";
import LoadingSpinner from "../components/LoadingSpinner";
import WorkshopDrawer from "../sections/header/WorkshopDrawer";
import { GARAGE_ROLE } from "../constants";
import './workshopstyles.scss'

const drawerWidth = 240;

interface IPROPS {
  liftingName: any;
}

const WorkshopMasterLayout: React.FC<IPROPS> = ({ liftingName }) => {
  const [openInventory, setOpenInventory] = useState(true);
  const [mobileDrawerOpen, setMobileDrawerOpen] = useState(false);

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const isGarageAdminLoggedIn = localStorage.getItem(GARAGE_ROLE);

  const handleInventoryToggle = () => {
    setOpenInventory(!openInventory);
  };

  const handleMobileDrawerToggle = () => {
    setMobileDrawerOpen(!mobileDrawerOpen);
  };

  return (
    <Box sx={{ display: "flex", height: "80px" }}>
      {/* <CssBaseline /> */}
      <AppBar
        position="fixed"
        elevation={0}
        sx={{
          width: {
            xs: "100%", // Full width on mobile
            md: `calc(100% - ${drawerWidth}px)`, // Original structure for desktop
          },
          ml: {
            xs: 0, // No margin on mobile
            md: `${drawerWidth}px`, // Original margin for desktop
          },
          backgroundColor: "#fff",
          color: "#1e1e1e",
          height: "80px",
        }}
      >
        <Toolbar sx={{ justifyContent: "space-between" }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <IconButton
              size="small"
              onClick={handleMobileDrawerToggle}
              sx={{
                display: { xs: "flex", md: "none" }, // Only show on mobile/tablet
                color: "#1e1e1e",
              }}
            >
              {mobileDrawerOpen ? <CloseIcon /> : <MenuIcon />}
            </IconButton>
            <Typography
              variant="h6"
              fontWeight="500"
              sx={{
                fontFamily: "Karbon-semi",
                // color: "#1a1a1a",
                fontSize: {
                  xs: "20px",
                  sm: "22px",
                  md: "28px", // Original size for desktop
                },
                marginLeft: {
                  xs: 0,
                  md: "10px", // Original margin for desktop
                },
                marginTop: {
                  xs: 0,
                  md: "20px", // Original margin for desktop
                },
              }}
            >
              {/* {liftingName} */}
              {isGarageAdminLoggedIn === "garage_tenant_admin"
                ? "Admin"
                : "Workshop Admin"}
            </Typography>
          </Box>
        </Toolbar>
      </AppBar>

      <WorkshopDrawer
        mobileOpen={mobileDrawerOpen}
        onMobileClose={handleMobileDrawerToggle}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          bgcolor: "#f3f4f6",
          p: {
            xs: 2, // Less padding on mobile
            md: 3, // Original padding for desktop
          },
          minHeight: "100vh",
          mt: {
            xs: "64px", // Mobile AppBar height
            md: "64px", // Original margin top
          },
        }}
        style={{ background: "#F3F3F3" }}
      >
        <div className="post d-flex flex-column-fluid" id="kt_post">
          <div id="kt_content_container" className="w-100">
            <Suspense fallback={<LoadingSpinner />}>
              <Outlet />
            </Suspense>
          </div>
        </div>
      </Box>
    </Box>
  );
};

export default WorkshopMasterLayout;
